var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.853,
    height: 25.853,
    viewBox: "0 0 25.853 25.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopped",
    transform: "translate(-619.855 -1099.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked-out-icon-green",
    transform: "translate(619.855 1099.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked-out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M632.782,1125.161a12.927,12.927,0,1,1,12.927-12.927,12.941,12.941,0,0,1-12.927,12.927",
    transform: "translate(-619.855 -1099.308)",
    fill: "#e21313",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M632.3,1110.276l3.909-3.909a1.043,1.043,0,0,0,0-1.475,1.068,1.068,0,0,0-1.477,0l-3.908,3.908-3.909-3.908a1.043,1.043,0,0,0-1.781.738,1.032,1.032,0,0,0,.306.738l3.908,3.909-3.909,3.908a1.046,1.046,0,0,0-.3.739,1.043,1.043,0,0,0,1.781.738l3.909-3.909,3.907,3.908a1.044,1.044,0,1,0,1.478-1.475Z",
    transform: "translate(1.959 1.959)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopped);
export default __webpack_public_path__ + "static/media/stopped.8d940fc6e88f9373037a6175029e2170.svg";
export { ForwardRef as ReactComponent };